import React,{createContext,useState} from 'react'
import {PRODUCTS} from '../products';


export const shopContext=createContext();

const getDefaultvalue=()=>{
    let cart={};
    for(let i=1;i<=PRODUCTS.length;i++){
        cart[i]=0
    }
    return cart;
}
export const ShopContextProvider=(props)=>{
    const [cartValue,setCartvalue]=useState(getDefaultvalue());
    const TotalPrice =()=>{
        let TotalAmount=0;
        for(const item in cartValue){
            if(cartValue[item]>0){
                let itemInfo=PRODUCTS.find((product)=>product.id===Number(item));
                TotalAmount+=itemInfo.Price* cartValue[item] ;
            }
        }
        return TotalAmount;
    };
    const AddToCart=(itemsId)=>{
        setCartvalue((prev)=>({...prev,[itemsId]:prev[itemsId]+1}))
    };
    const RemoveToCart=(itemsId)=>{
        setCartvalue((prev)=>({...prev,[itemsId]:prev[itemsId]-1}))
    }
    // fetching data from input section and Updating
    const updateValue=(itemsId,value)=>{
        setCartvalue((prev)=>({...prev,[itemsId]:value}))
    }
    const contextApi={cartValue,AddToCart,RemoveToCart,updateValue,TotalPrice};
    return <shopContext.Provider value={contextApi}>{props.children}</shopContext.Provider>;
}